import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const GlobalUserActions = require('../../actions/GlobalUserActions');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        type: PropTypes.oneOf(Object.values(Globals.users.type)).isRequired,
        local_role_type: PropTypes.oneOf(Object.values(Globals.users.local_role_type)),
    }),
}

const defaultProps = {};

class AdminUserLocalRoleEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateUserActionId: null,
            updateError: null,
        };

        this.updateUserInfo = this.updateUserInfo.bind(this);
        this.unsubscribes = [AdminGlobalUserStore.listen(this.onGlobalUserStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onGlobalUserStoreChange(state) {
        if (state.action.id === this.state.updateUserActionId) {
            let newState = { updateUserActionId: null };
            if (!state.action.error) {
                newState.updateError = null;
            }
            else {
                newState.updateError = state.action.error;
            }

            return this.setState(newState);
        }

    }

    updateUserInfo(newRoleType) {
        if (confirm("Are you sure you want to change this user's role?")) {
            const actionId = uuid.v4();
            this.setState({ updateUserActionId: actionId }, () => {
                GlobalUserActions.adminUpdateUser(actionId, { userId: this.props.user.id, local_role_type: newRoleType });
            });
        }

    }

    render() {
        const types = Object.values(Globals.users.local_role_type);
        if (!types.length) {
            return null;
        }

        if (!this.props.user) {
            return null;
        }

        if (this.props.user.type !== Globals.users.type.LOCAL) {
            return null;
        }

        const roleStrings = Strings['en'].user.local_role_type;
        let selectedRoleString; 
        const roleMenuItems = types.map((type) => {
            let itemClass = 'AriaMenuButton-menuItem';
            if (this.props.user.local_role_type === type) {
                itemClass += ' is-selected';
                selectedRoleString = roleStrings[type];
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={type}>
                    <MenuItem
                        className={itemClass}
                        value={type}
                        text={roleStrings[type]}
                    >
                        {roleStrings[type]}
                    </MenuItem>
                </li>
            );
        });

        return (
            <div className="org-plan-chooser">
                <label htmlFor="user-local-role">Local User Role</label>
                <Wrapper id="user-local-role" className='AriaMenuButton margin-left-sm' onSelection={this.updateUserInfo}>
                    <Button className='AriaMenuButton-trigger'>
                        {!!selectedRoleString ? selectedRoleString : 'select a role'}
                    </Button>
                    <Menu>
                        <ul className='AriaMenuButton-menu'>
                            {roleMenuItems}
                        </ul>
                    </Menu>
                </Wrapper>
                <ErrorBox error={this.state.updateError} />
            </div>
        );
    }
}

AdminUserLocalRoleEditor.propTypes = propTypes;
AdminUserLocalRoleEditor.defaultProps = defaultProps;

export default AdminUserLocalRoleEditor;